export function btoa(bin) {
    return window.btoa(bin);
}

export function atob(ascii) {
    return window.atob(ascii);
}
